import { useQuery } from '@tanstack/react-query';
import { fxRatesService } from '@/services/fx-rates/fx-rates-service';
import { queryKeys } from '@/services/query-keys';

export const useFxRates = () => {
  return useQuery({
    queryKey: queryKeys.fxRates.current,
    queryFn: () => fxRatesService.getCurrentRates(),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
};
